<fgb-membership-details
  [subscribedProduct]="purchasedMembershipProduct"
  [availableMembershipProducts]="membershipPortalProducts"
></fgb-membership-details>
<ng-container *ngIf="allProducts == 0">
  <div>
    <img class="no-subs-image d-flex mx-auto" [src]="'placeholders/no-subscriptions.svg' | contentAssetImage" />
    <h5 class="text-primary text-center mt-3 mb-0 fw-bold text-uppercase">SUBSCRIPTIONS</h5>
    <p class="text-info text-center font-size-14">Currently Unavailable</p>
  </div>
</ng-container>
